import request from "@/utils/request"; // 获取列表

export function fetchList(data) {
  return request({
    url: "/whg-park/api/blackList/list",
    method: "post",
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: "/whg-park/api/blackList/insert",
    method: "post",
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: "/whg-park/api/blackList/get",
    method: "post",
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: "/whg-park/api/blackList/delete",
    method: "post",
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: "/whg-park/api/blackList/update",
    method: "post",
    data: data
  });
} // 批量新增

export function insertBatch(data) {
  return request({
    url: "/whg-park/api/blackList/insertBatch",
    method: "post",
    data: data
  });
}
export function importBatch(data) {
  return request({
    url: "/whg-park/api/blackList/import",
    method: "post",
    data: data
  });
}